<template>
  <a-modal :title="$t('preCall.permissions.title', {device: props.device})" @close="emit('close')">
    <p>{{ $t('preCall.permissions.instruction', {device: props.device}) }}</p>
    <img class="w--100 tutorial" :src="`/tutorials/${imgTutorial}.gif`" alt="" />
    <template #footer>
      <a-button @click="emit('retryAndClose')">{{ $t('preCall.permissions.ok') }}</a-button>
    </template>
  </a-modal>
</template>

<script setup>
const props = defineProps({
  device: {type: String},
})
const emit = defineEmits(['close', 'retryAndClose'])

const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
const platform = navigator.userAgent.toLowerCase()
let deviceType = 'PC'
let browser = 'Chrome'
let imgTutorial = props.device

if (/android/i.test(platform)) {
  deviceType = 'Android'
} else if (/iphone|ipad|ipod/i.test(platform)) {
  deviceType = 'iOS'
}

if (platform.includes('edg')) {
  browser = 'Edge'
} else if (platform.includes('firefox')) {
  browser = 'Firefox'
} else if (platform.includes('crios') || platform.includes('chrome')) {
  browser = 'Chrome'
} else if (platform.includes('safari') && !platform.includes('crios') && !platform.includes('fxios')) {
  browser = 'Safari'
}

if (isMobile) {
  if (deviceType === 'iOS') {
    imgTutorial = browser === 'Chrome' ? 'chrome-ios' : 'safari'
  } else if (deviceType === 'Android') {
    if (browser === 'Chrome') {
      imgTutorial = 'chrome-android'
    } else if (browser === 'Firefox') {
      imgTutorial = 'firefox'
    } else {
      imgTutorial = 'edge'
    }
  }
}
</script>
<style lang="scss">
.tutorial {
  height: 500px;
  object-fit: contain;
}
</style>
